import { type Dispatch, bindActionCreators } from '@reduxjs/toolkit';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link as ReactRouterDomLink,
  type LinkProps as ReactRouterDomLinkProps,
} from 'react-router-dom';

import { RCV_ROUTING } from '../../actions/routing';
import type { RootState } from '../../reducers';

type LinkProps = ReactRouterDomLinkProps;

const Link = (props: LinkProps) => {
  const { t } = useTranslation(['validation']);
  const dispatch = useDispatch();
  const push = bindActionCreators(
    (path: string) => (_dispatch: Dispatch) => _dispatch({ type: RCV_ROUTING, path }),
    dispatch,
  );

  const block = useSelector((state: RootState) => state.assignmentDrafts.unsaved);

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      if (block && !confirm(t('confirmUnsavedChanges', { ns: 'validation' }))) {
        e.preventDefault();
        e.stopPropagation();
      } else {
        if (props.onClick) {
          props.onClick(e);
        }
        push(props.to as string);
      }
    },
    [props.onClick, props.to, block],
  );

  return <ReactRouterDomLink {...props} onClick={onClick} />;
};

export default Link;
